import {OfferQuestConditionContainer} from '../../../privateOffer/offerQuestConditions/OfferQuestConditionContainer';
import {OfferQuestConditionLogicEnum} from '../../../privateOffer/offerQuestConditions/OfferQuestConditionLogicEnum';
import {IOfferDescriptionVisualParameter} from '../../../privateOffer/offerDescriptions/visualizations/IOfferDescriptionVisualParameter';
import {IOfferDescriptionRewardParameter} from '../../../privateOffer/offerDescriptions/rewards/IOfferDescriptionRewardParameter';
import {IOfferQuestCondition} from '../../../privateOffer/offerQuestConditions/IOfferQuestCondition';
import {IOfferDescription} from '../../../privateOffer/offerDescriptions/IOfferDescription';
import {Constants_Offer} from '../../../privateOffer/Constants_Offer';
import {PrivateOfferStateEnum} from '../../../privateOffer/PrivateOfferStateEnum';
import {PrivateOfferDataEvent} from '../../../privateOffer/PrivateOfferDataEvent';
import {OfferDescriptionVisualQuestAcceptDialog} from '../../../privateOffer/offerDescriptions/visualizations/OfferDescriptionVisualQuestAcceptDialog';
import {OfferDescriptionVisualIsoObject} from '../../../privateOffer/offerDescriptions/visualizations/OfferDescriptionVisualIsoObject';
import {OfferDescriptionVisuals} from '../../../privateOffer/offerDescriptions/OfferDescriptionVisuals';
import {IPrivateOfferModel} from '../../../privateOffer/offerQuestConditions/IPrivateOfferModel';
import {BasicOfferDescriptionVisualFactory} from '../../../privateOffer/offerDescriptions/visualizations/BasicOfferDescriptionVisualFactory';
import {BasicOfferRewardFactory} from '../../../privateOffer/offerDescriptions/rewards/BasicOfferRewardFactory';
import {BasicOfferQuestConditionFactory} from '../../../privateOffer/offerQuestConditions/BasicOfferQuestConditionFactory';
import {BasicOfferDescriptionFactory} from '../../../privateOffer/offerDescriptions/BasicOfferDescriptionFactory';
import {BasicPrivateOfferVOFactory} from '../../../privateOffer/BasicPrivateOfferVOFactory';
import {OfferFailedVisualExecution} from '../../../privateOffer/OfferFailedVisualExecution';
import {BasicPrivateOfferVO} from '../../../privateOffer/BasicPrivateOfferVO';
/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 09.04.13
 * Time: 16:35
 */

import { BasicData } from "./BasicData";
import { CommandController } from './../../../commanding/CommandController';
import { info } from "../../../logging/info";

export class BasicPrivateOfferData extends BasicData implements IPrivateOfferModel {

    protected _activeOffers: BasicPrivateOfferVO[];
    protected _failedVisualExecutions: OfferFailedVisualExecution[];

    // factorys
    protected _offerFactory: BasicPrivateOfferVOFactory;
    protected _offerDescriptionFactory: BasicOfferDescriptionFactory;
    protected _offerQuestConditionFactory: BasicOfferQuestConditionFactory;
    protected _offerRewardFactory: BasicOfferRewardFactory;
    protected _offerDescriptionVisualFactory: BasicOfferDescriptionVisualFactory;

    constructor() {
        super();
        this._activeOffers = [];
        this._failedVisualExecutions = [];
        this.initOfferFactory();
        //traceAllDefinitions();
    }

    protected initOfferFactory(): void {
        this._offerFactory = new BasicPrivateOfferVOFactory(this);
        this._offerDescriptionFactory = new BasicOfferDescriptionFactory(this);
        this._offerQuestConditionFactory = new BasicOfferQuestConditionFactory(this);
        this._offerRewardFactory = new BasicOfferRewardFactory(this);
        this._offerDescriptionVisualFactory = new BasicOfferDescriptionVisualFactory(this);
    }

		/*override*/ public executeUpdate(now: number): void {
        // have to track active offers
        if (this._activeOffers.length > 0) {
            for (let offerVO of this._activeOffers) {
                // if an offer has a duration for the actual state, check if time is expired
                if (!offerVO.hasInfiniteTime && !offerVO.hasRequestedNewTime && offerVO.remainingSeconds <= 0 && offerVO.secondsOverTime % 5 == 0)  // ask every 5 seconds
                {
                    this.sendCheckDuration(offerVO.id);      // aks server to check duration and triggers next offer step
                    offerVO.hasRequestedNewTime = true;
                }
            }
        }

        // have to try failed visual executions
        if (this._failedVisualExecutions.length > 0) {
            let deleteIndex: number = -1;
            for (let failedExecution of this._failedVisualExecutions) {
                if (failedExecution.tries > 5)													// after 5 tries give it up
                {
                    deleteIndex = this._failedVisualExecutions.indexOf(failedExecution);
                }
                else if (!failedExecution.visualParameter.execute(failedExecution.offerVO))     // execute
                {
                    failedExecution.tries = failedExecution.tries + 1;
                }							// if failed, increase try
                else {
                    this._failedVisualExecutions.splice(this._failedVisualExecutions.indexOf(failedExecution), 1);
                }								// if success, remove from failed executions
            }
            if (deleteIndex > -1)																// if one is over five tries, delete it
            {
                this._failedVisualExecutions.splice(deleteIndex, 1);
            }
        }
    }

    public onStartCycleReady(): void {
        if (this._activeOffers.length > 0) {
            for (let offerVO of this._activeOffers) {

                let visualComponent: OfferDescriptionVisuals = (<OfferDescriptionVisuals>offerVO.getDescriptionByName(Constants_Offer.VISUAL_COMPONENT_CONTAINER));
                if (visualComponent) {
                    visualComponent.visuals.forEach(
                        (visual: any, k: any, m: Map<any, any>) => {
                            if (visual instanceof OfferDescriptionVisualIsoObject) {
                                info("got a " + visual.name + " here");
                            } else if (visual instanceof OfferDescriptionVisualQuestAcceptDialog) {
                                if (((<OfferDescriptionVisualQuestAcceptDialog>visual)).autoShow) {
                                    ((<OfferDescriptionVisualQuestAcceptDialog>visual)).execute(offerVO);
                                }
                            }
                        }
                    );
                }
            }
        }
    }

		/*override*/ public destroy(): void {
        // delete all Offers
        for (let offerVO of this._activeOffers) {
            this.dispatchEvent(new PrivateOfferDataEvent(PrivateOfferDataEvent.PRIVATE_OFFER_REMOVED, offerVO));
            offerVO.dispose();
        }

        this._failedVisualExecutions = null;

        this._offerFactory.dispose();
        this._offerDescriptionFactory.dispose();
        this._offerQuestConditionFactory.dispose();
        this._offerRewardFactory.dispose();
        this._offerDescriptionVisualFactory.dispose();

        super.destroy();
    }

    /**
     * parse offer finish state, which will be send from server over msp command
     * @param offerId id of the ended offer
     * @param offerState finish state (successful, failed)
     */
    public offerFinished(offerId: number, offerState: number): void {
        let deleteOffer: BasicPrivateOfferVO = this.getOfferById(offerId);
        if (deleteOffer) {
            deleteOffer.changeState(PrivateOfferStateEnum.getEnumByServerEventID(offerState));		// change over state to current finish state
            this.checkVisualExecution(deleteOffer);									  // check if visual component have something to do in this finish state

            if (PrivateOfferStateEnum.isFinishedState(deleteOffer.offerState))     // if offer really in finish state, delete it
            {
                let deleteIndex: number = this._activeOffers.indexOf(deleteOffer);
                if (deleteIndex > -1) {
                    this.offerFinishedHook(deleteOffer);
                    this._activeOffers.splice(deleteIndex, 1);
                    this.dispatchEvent(new PrivateOfferDataEvent(PrivateOfferDataEvent.PRIVATE_OFFER_REMOVED, deleteOffer));
                }
            }
        }
    }

    protected offerFinishedHook(deleteOffer: BasicPrivateOfferVO): void {

    }

    /**
     * Check all visual components of this offer, if they have something to do in current state
     * @param offerVO offer to check
     */
    protected checkVisualExecution(offerVO: BasicPrivateOfferVO): void {
        let visuals: OfferDescriptionVisuals = (<OfferDescriptionVisuals>offerVO.getDescriptionByName(Constants_Offer.VISUAL_COMPONENT_CONTAINER));
        if (visuals) {
            visuals.visuals.forEach(
                (visual: any, k: any, m: Map<any, any>) => {
                    if (visual.toExecuteInState(offerVO.offerState))  	// check if component have to execute in current state
                    {
                        if (visual.execute(offerVO))						// execute visual component
                        {
                            CommandController.instance.executeCommand(visual.getCommandName(), offerVO);
                        }
                    }
                }
            );
        }
    }

    //        /**
    //         * parse new duration correction of this offer
    //         * @param params
    //         */
    //        public function parse_ODC( params:Object ):void
    //        {
    //            getOfferById( parseInt(params.OID) ).updateDuration( params.RS == null ? -1 : parseInt(params.RS));
    //        }

    /**
     * Send an offer accept
     * @param offerId
     * @param choice 0 = refuse, 1 = accept
     */
    public sendOfferQuestAccept(offerId: number, choice: number): void {
        // must be overriden by subclass
    }

    /**
     * Send an offer pay
     * @param offerId
     * @param choice 0 = refuse, 1 = accept
     */
    public sendOfferPay(offerId: number, choice: number): void {
        // must be overriden by subclass
    }

    /**
     * Triggers a check of remaining duration on server
     * Reaction: server will be sent back ab odc if the offer has remaining seconds left, otherwise a new state will be sent over POLCommand
     * @param offerId
     */
    public sendCheckDuration(offerId: number): void {
        // must be overriden by subclass
    }

    /*****************************************************
     * Creating description instance out of descriptions *
     *****************************************************/
    /**
     * Creates a new offer description object for given name and initialize it with given params
     * @param name
     * @param params
     * @return
     */
    public createOfferDescriptionObject(name: string, params: any): IOfferDescription {
        if (name) {
            let offerDescription: IOfferDescription = this._offerDescriptionFactory.createOfferDescriptionObject(name, params);
            return offerDescription;
        }
        return null;
    }

    /**
     * Creates a new offer quest condition object for given name and initialize it with given params
     * @param name
     * @param params
     * @param logic
     * @return
     */
    public createQuestCondition(name: string, params: any): IOfferQuestCondition {
        if (name) {
            return this._offerQuestConditionFactory.createOfferQuestCondition(name, params);
        }
        return null;
    }

    /**
     * Creates a new offer reward parameter object for given name and initialize it with given params
     * @param name
     * @param params
     * @return
     */
    public createOfferDescriptionRewardObject(name: string, params: any): IOfferDescriptionRewardParameter {
        let offerDescriptionReward: IOfferDescriptionRewardParameter = this._offerRewardFactory.createOfferRewardObject(name, params);
        return offerDescriptionReward;
    }

    /**
     * Creates a new offer visual parameter object for given name and initialize it with given params
     * @param name
     * @param params
     * @return
     */
    public createOfferDescriptionVisualObject(name: string, params: any): IOfferDescriptionVisualParameter {
        let offerDescriptionVisual: IOfferDescriptionVisualParameter = this._offerDescriptionVisualFactory.createOfferDescriptionVisualObject(name, params);
        return offerDescriptionVisual;
    }

    /******************************************
     * Private offer utils *
     ******************************************/
    /**
     * Tries to get an offer from active offers by id
     * @param offerId
     * @return
     */
    public getOfferById(offerId: number): BasicPrivateOfferVO {
        for (let offerVO of this._activeOffers) {
            if (offerId == offerVO.id) {
                return offerVO
            }
        }
        return null;
    }

    /**
     * Gets all active private offer, which have set visual parameter with given name
     * @param name
     * @return
     */
    public getPrivateOffersWithVisualParamter(name: string): BasicPrivateOfferVO[] {
        let result: BasicPrivateOfferVO[] = [];
        for (let offerVO of this._activeOffers) {
            let offerVisuals: OfferDescriptionVisuals = (<OfferDescriptionVisuals>offerVO.getDescriptionByName(Constants_Offer.VISUAL_COMPONENT_CONTAINER))
            if (offerVisuals && offerVisuals.visuals[name] !== undefined) {
                result.push(offerVO);
            }
        }
        return result;
    }

    /***************
     * Debug stuff *
     ***************/
    private traceAllDefinitions(): void {
    }

    public createQuestConditionContainer(params: any, logic: OfferQuestConditionLogicEnum = null): OfferQuestConditionContainer {
        let offerQuestCondition: OfferQuestConditionContainer = this._offerQuestConditionFactory.createOfferQuestContainer(params);
        if (offerQuestCondition) {
            ((<OfferQuestConditionContainer>offerQuestCondition)).setLogic(logic);
        }

        return offerQuestCondition;
    }
}

